import React from 'react';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        //margin: theme.spacing(1),
        display: 'flex',
        alignItems: 'center'
    },
    buttonProgress: {
        marginRight: theme.spacing(1),
    },
}));

const SaveButton = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                {
                    (props.isLoading) &&
                    <CircularProgress size={25} color="secondary" className={classes.buttonProgress} />
                }

                <Button onClick={props.onClick}
                    color="primary" size="small" disabled={props.isLoading || props.disabled}
                    startIcon={<SaveIcon />}>Save</Button>
            </div>
        </div>
    )
}

SaveButton.defaultProps = {
    onClick: () => { },
    isLoading: false
}

export default SaveButton;